import { render } from "./Home.vue?vue&type=template&id=e051a182"
const script = {}
script.render = render

export default script